module.exports = __webpack_public_path__ + "static/media/video_2_img.dacfe4bd.jpg";